import SidebarItem from './sidebar-item';
import SubMenu, { SubMenuType, getSidebarItemImage } from './sidebar-sub-menu';
import { useState } from 'react';

export type SidebarItemWithSubMenuProps = {
  menuType: SubMenuType;
  activeFrame: string;
  locationId?: number;
  title?: string;
};

export default function SidebarItemWithSubMenu({
  title,
  menuType,
  activeFrame,
  locationId
}: SidebarItemWithSubMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  return (
    <>
      <SidebarItem
        title={title}
        to={'/' + activeFrame}
        replace={true}
        onClick={(e: any) => setAnchorEl(e.currentTarget)}
      >
        {getSidebarItemImage(menuType)}
      </SidebarItem>
      <SubMenu menuType={menuType} locationId={locationId} anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)} />
    </>
  );
}
